import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,

} from "@mui/material";
import CompanyLogo from "../../common/assests/reyleafLogo.svg";
import Paginations from "../../common/pagination/Paginations";
import PeopleIcon from '@mui/icons-material/People';
import { useSelector } from "react-redux";
import { allForumListApi } from "../../api";
import { useParams } from "react-router-dom";
import Loader from "../../common/loader/Loader";
import configuration from "../../config/Config";


const JoinedForum = () => {


  const token = useSelector((state) => state?.user?.user?.token);
  const { id } = useParams();
  const [loading,setLoading]=useState(false)
  const [forumDataList,setForumeDataList]=useState([]);
  const [totalPages,setTotalPages]=useState()
  const [currentPage,setCurrentPage]=useState(1)


   const handleForumList = async () => {
    try { 
      setLoading(true);
      const response = await allForumListApi({token,currentPage,id});
      setForumeDataList(response?.data|| []);
      // console.log("forums details",response);
      setCurrentPage(response?.currentPage)
      setTotalPages(response?.totalPages)
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  };

  


  useEffect(() => {
    handleForumList();
  }, [currentPage]);


  const handlePageChange = (page) => {
    setLoading(true);
    setCurrentPage(page);
  };

  

  return (
    <>

      {loading ? (
        <Loader variant="cardList" />
      ):(
      <Box
        sx={{
          borderRadius: "24px",
          background: "#FFF",
          boxShadow: "3px 2px 20px 0px rgba(0, 0, 0, 0.04)",
          padding: "16px",
          width: "100%",
          maxWidth: "1460px",
          margin: "auto",
          boxSizing: "border-box",
          overflow: "hidden",
          marginTop:'40px'
        }}
      >
        <Typography
          sx={{
            fontSize: "20px",
            fontWeight: "500",
            color: "#362B24",
            fontFamily: "Heebo",
          }}
        >
          All Platform Events
        </Typography>

        <Box>
            {forumDataList.length>0 ?(
              forumDataList.map((item) => (
                <Box
                  key={item._id}
                  sx={{
                    borderRadius: "22px",
                    background: "#FFF",
                    boxShadow: "1px 2px 30px 0px rgba(0, 0, 0, 0.06)",
                    maxWidth: "1380px",
                    height: "auto",
                    minHeight: "116px",
                    flexShrink: 0,
                    marginBottom: "16px",
                    marginTop: "10px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "16px",
                    boxSizing: "border-box",
                    flexDirection: { xs: "column", sm: "row" },
                  }}
                >
                  {/* Left Side: Image and Event Details */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      flexDirection: { xs: "column", sm: "row" },
                      gap: { xs: "20px", sm: "0px" },
                      width: "100%",
                    }}
                  >
                    <img
                     src={
                      item?.picture
                        ? `${configuration.cdnFront}/${item?.picture}`
                        : CompanyLogo
                    }
                      alt="event-img"
                      className="joined-forum-img"
                      style={{
                        borderRadius: "13px",
                        marginRight: "16px",
                        width: "91px",
                        height: "96px",
                        objectFit: "cover",
                      }}
                    />
                    <Box>
                      <Box 
                      sx={{ 
                        display: "flex",
                         alignItems: "center",
                         justifyContent: {xs:'space-between',sm:'start'},
                          mb: 1,
                          gap:1 ,}}
                      >
                        <Typography
                          sx={{
                            fontSize: "16px",
                            fontWeight: "600",
                            color: "#362B24",
                            fontFamily: "Heebo",
                          }}
                        >
                          {item?.title||""}
                        </Typography>
                        <Box
                  sx={{
                    borderRadius: '28px',
                    background: '#362B24',
                    boxShadow: '1px 2px 30px 0px rgba(0, 0, 0, 0.06)',
                    // width: '97px',
                    height: '25px',
                    display: 'flex',
                    alignItems:"stretch",
                    justifyContent:'center',
                    padding:'6px',
                   gap:'3px',
                    flexShrink: 0,
                   
                    
                  }}
                >
                 <PeopleIcon sx={{color:'#FFF',width:'11px',height:'11px'}}/>
                  <Typography sx={{ color: '#FFF', fontSize: '9px' }}>
                  {item?.joinedCount||"0"} Members
                  </Typography>
                </Box>
    
                      </Box>
  
                      <Typography
                        sx={{
                          fontSize: "12px",
                          color: "#7D6F6F",
                          fontFamily: "Heebo",
                          // overflow: 'hidden',
                          // textOverflow: 'ellipsis',
                          // whiteSpace: 'nowrap',
                          maxWidth: "900px",
                          width: "100%",
                          opacity: "0.6",
                        }}
                      >
                        {item?.description||""}
                      </Typography>
                    </Box>
                  </Box>
    
               
                
                </Box>
              ))
            ):(
                <div style={{textAlign:'center'}}>
                No Data Found
                </div>
            )}
        </Box>
        <Paginations
        totalPages={totalPages}
        currentPage={currentPage}
        onPageChange={handlePageChange}
        disabled={loading}
      />
      </Box>
      )}

   
    </>
  );
};

export default JoinedForum;
